import React from 'react';
import { Route } from 'react-router-dom';

import { resultsRoute } from '../../../features/divestitureDiagnostic/routes';
import { surveySectionRoute } from '../../../Survey/routes';
import ResultsSidebar from './ResultsSidebar/ResultsSidebar';
import SurveySideBar from './SurveySidebar/SurveySidebar';

import './DivestitureDiagnosticSidebarRouter.scss';

const DivestitureDiagnosticSidebarRouter = () => {
  return (
    <div className="divestiture-diagnostic-sidebar">
      <Route path={surveySectionRoute}>
        <SurveySideBar />
      </Route>
      <Route path={resultsRoute}>
        <ResultsSidebar />
      </Route>
    </div>
  );
};

export default DivestitureDiagnosticSidebarRouter;
